import { useCurrentSelf } from '../auth/useCurrentSelf'
import { useRole } from '../auth/useRole'

export function useTicketAccess() {
  const { data } = useCurrentSelf()
  const { isSuperAdmin, isOrgAdmin, isRoleResolved } = useRole()
  // Never grant a cross-tenant capability from localStorage or a role preview.
  const isTicketDelegate = data?.authUser?.can_manage_all_tickets === true && !isSuperAdmin
  return {
    isRoleResolved,
    canAccessTickets: isSuperAdmin || isOrgAdmin || isTicketDelegate,
    seesAllTickets: isSuperAdmin || isTicketDelegate,
    isTicketDelegate,
    canCreateTickets: isSuperAdmin || isOrgAdmin,
    canManageHomeTickets: isOrgAdmin,
    homeOrganizationId: String(data?.authUser?.home_organization_id ?? data?.authUser?.organization_id ?? ''),
  }
}
